import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Theme } from '../../theme';
import { AutoSaveIndicator } from './AutoSaveIndicator';
import InputLabel from './InputLabel';

type Params = {
  label: string;
  completed?: boolean;
  required?: boolean;
  optional?: boolean;
  loading?: boolean;
  hint?: React.ReactNode;
  pendingChanges?: React.ReactNode;
};

const AutoSaveInputLabel: React.FC<React.PropsWithChildren<Params>> = ({
  label,
  completed,
  optional,
  required,
  loading,
  hint,
  pendingChanges,
}) => {
  const { t } = useTranslation();

  return useMemo(() => {
    return (
      <>
        <InputLabel label={label} required={required} hint={hint} />
        {optional && (
          <Optional className="ms-2">{t('form.general.optional')}</Optional>
        )}
        <div className="d-inline-block ms-2">
          {pendingChanges}
          <AutoSaveIndicator loading={loading} completed={completed} />
        </div>
      </>
    );
  }, [completed, hint, label, loading, required, optional, pendingChanges, t]);
};

export default AutoSaveInputLabel;

const Optional = styled('span')({
  color: Theme.color.gray3,
});
